import React from 'react'
import cn from 'classnames'
import { SATOSHI_UNIT, USD_UNIT, type BsvUnit } from 'lib/bsv-util'
import styles from './upvalue.module.scss'

interface LocalCurrencyTabsProps {
    bsvUnit: BsvUnit | string
    onChange: (unit: BsvUnit) => void
}

export function LocalCurrencyTabs({ bsvUnit, onChange }: LocalCurrencyTabsProps) {
    const useUsd = bsvUnit === USD_UNIT

    return (
        <div className={styles.unitTabs}>
            <div
                className={cn(
                    styles.unitTab,
                    styles.bitcoinUnit,
                    !useUsd && styles.activeBitcoinUnit,
                )}
                onClick={() => onChange(SATOSHI_UNIT)}
            >
                <i className="fa fa-btc" />
            </div>
            <div
                className={cn(styles.unitTab, styles.usdUnit, useUsd && styles.activeUsdUnit)}
                onClick={() => onChange(USD_UNIT)}
            >
                $
            </div>
        </div>
    )
}
